import { MEMBERSHIP_PATH } from '~/modules/membership/domain/purchase';
import { MEMBERSHIP_TEXT } from '~/modules/membership/ui/text';

export const SUPPORT_CHAT_LINK = '__support__';

interface FooterSectionItem {
  title: string;
  link: string;
  dataLink?: string;
  external?: boolean;
  requireAuth?: boolean;
  /**
   * The CityDrinks Club entry: shown only to a company with memberships,
   * reported as `Membership: Entry Clicked`, and a guest signs in straight
   * to the club page.
   */
  club?: true;
}

interface FooterSection {
  title: string;
  items: FooterSectionItem[];
}

export interface FooterConfig {
  sections: FooterSection[];
  contactColumn?: boolean;
}

export const footerConfigs: Record<string, FooterConfig> = {
  heimkaup: {
    contactColumn: true,
    sections: [
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals#terms-and-conditions',
            dataLink: 'footer-terms',
          },
          {
            title: 'legals:privacyPolicy',
            link: '/legals#privacy-policy-main',
            dataLink: 'footer-privacy',
          },
        ],
      },
    ],
  },
  citydrinks: {
    contactColumn: true,
    sections: [
      {
        title: 'company',
        items: [
          {
            title: 'ourStory',
            link: '/our-story',
            dataLink: 'footer-our-story',
          },
          { title: 'brand', link: '/brand', dataLink: 'footer-brand' },
          {
            title: 'contactUs',
            link: SUPPORT_CHAT_LINK,
            dataLink: 'footer-contact-us',
          },
          { title: 'careers', link: '/careers', dataLink: 'footer-careers' },
          { title: 'legals', link: '/legals', dataLink: 'footer-legals' },
        ],
      },
      {
        title: 'media',
        items: [
          {
            title: 'influencers',
            link: '/influencers',
            dataLink: 'footer-influencers',
          },
          {
            title: 'blog',
            link: '__blog__',
            dataLink: 'footer-blog',
            external: true,
          },
        ],
      },
      {
        title: 'information',
        items: [
          {
            title: 'policies',
            link: '/shipping-return',
            dataLink: 'footer-shipping',
          },
          {
            title: 'refundPolicy',
            link: '/refund',
            dataLink: 'footer-refound',
          },
          { title: 'faq', link: '/faq', dataLink: 'footer-faq' },
          {
            title: 'referAfriend',
            link: '/cabinet/referral',
            dataLink: 'footer-referral',
            requireAuth: true,
          },
          {
            title: MEMBERSHIP_TEXT.menuItem,
            link: MEMBERSHIP_PATH,
            dataLink: 'footer-club',
            requireAuth: true,
            club: true,
          },
        ],
      },
    ],
  },
  mcosmetic: {
    sections: [
      {
        title: 'company',
        items: [
          {
            title: 'contactUs',
            link: '/contacts',
            dataLink: 'footer-contact-us',
          },
          {
            title: 'legals',
            link: '/legals',
            dataLink: 'footer-terms-of-service',
          },
          {
            title: 'careerPage:title',
            link: '/careers',
            dataLink: 'footer-career',
          },
        ],
      },
    ],
  },
  electronium: {
    sections: [
      {
        title: 'customerCare',
        items: [
          {
            title: 'contactUs',
            link: '/customer-care',
            dataLink: 'footer-contact',
          },
          { title: 'payment', link: '/payment', dataLink: 'footer-payment' },
          { title: 'faq', link: '/faq', dataLink: 'footer-faq' },
        ],
      },
      {
        title: 'about',
        items: [{ title: 'aboutUs', link: '/about', dataLink: 'footer-about' }],
      },
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals#terms-and-conditions',
            dataLink: 'footer-terms',
          },
          {
            title: 'legals:privacyPolicy',
            link: '/legals#privacy-policy-main',
            dataLink: 'footer-privacy',
          },
        ],
      },
    ],
  },
  localee: {
    sections: [
      {
        title: 'about',
        items: [{ title: 'aboutUs', link: '/about', dataLink: 'footer-about' }],
      },
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals',
            dataLink: 'footer-terms',
          },
        ],
      },
    ],
  },
  default: {
    sections: [
      {
        title: 'legal',
        items: [
          {
            title: 'termsAndConditions',
            link: '/legals',
            dataLink: 'footer-terms',
          },
        ],
      },
    ],
  },
};
